module.exports = __webpack_public_path__ + "img/img2.2bb173ea.jpg";